import { css } from '@spectrum-web-components/base';
const styles = css`
    
`;
export default styles;